import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createUser, getUsers, updateUser } from '../api/usersApi';
import { queryKeys } from '../api/queryKeys';

export function useUsers(options = {}) {
  return useQuery({
    queryKey: queryKeys.users(),
    queryFn: getUsers,
    staleTime: 60 * 1000,
    ...options
  });
}

export function useCreateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createUser,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.users() })
  });
}

export function useUpdateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ recordId, fields }) => updateUser(recordId, fields),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.users() })
  });
}
